export function logStartupBanner() {
	console.log(
		`%c
  ##    ## ##     ## ##       ######## #### ######## ##    ##
  ##   ##  ##     ## ##          ##     ##  ##        ##  ##               Built with React, Tanstack, Moleculer and others.
  ##  ##   ##     ## ##          ##     ##  ##         ####                See our tech stack: https://stackshare.io/kultify/kultify
  #####    ##     ## ##          ##     ##  ######      ##                 Made with ❤️ in Nürnberg
  ##  ##   ##     ## ##          ##     ##  ##          ##                 Version ${
		import.meta.env.VITE_VERSION
	}
  ##   ##  ##     ## ##          ##     ##  ##          ##                 For more visit https://kultify.de
  ##    ##  #######  ########    ##    #### ##          ##
  `,
		"color: #36A0F2",
	);
}
